import { useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Lock } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import WarpField from "@/components/WarpField";

export default function AdminLogin() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  if (user) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await login(email, password);
      toast.success("Access granted.");
      navigate("/admin");
    } catch (err) {
      const detail = err?.response?.data?.detail;
      toast.error(typeof detail === "string" ? detail : "Access denied.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen bg-black flex items-center justify-center p-6 relative overflow-hidden grain-overlay scanlines" data-testid="admin-login-page">
      <div className="absolute inset-0 opacity-30">
        <WarpField density={100} speed={0.3} />
      </div>
      <div className="absolute inset-0 vignette" />

      <div className="relative w-full max-w-md">
        <div className="text-center mb-10">
          <div className="font-bodoni text-5xl mb-2">JITSUENT</div>
          <div className="font-mono text-[10px] tracking-[0.4em] text-neutral-500 cursor-blink">CREW ACCESS</div>
        </div>

        <form onSubmit={submit} className="border border-neutral-900 bg-black p-8 space-y-6" data-testid="admin-login-form">
          <div className="flex items-center gap-2 font-mono text-[10px] tracking-widest text-neutral-500">
            <Lock size={12} /> SECURE TRANSMISSION
          </div>
          <label className="block">
            <div className="font-mono text-[10px] text-neutral-500 tracking-widest mb-2">EMAIL</div>
            <input
              data-testid="login-email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="noir-input"
              required
            />
          </label>
          <label className="block">
            <div className="font-mono text-[10px] text-neutral-500 tracking-widest mb-2">PASSWORD</div>
            <input
              data-testid="login-password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="noir-input"
              required
            />
          </label>
          <button type="submit" disabled={busy} data-testid="login-submit" className="btn-noir w-full justify-center">
            {busy ? "AUTHENTICATING..." : "ENTER"}
          </button>
        </form>

        <div className="mt-6 text-center">
          <a href="/" className="font-mono text-[10px] text-neutral-600 tracking-widest hover:text-white">← BACK TO SITE</a>
        </div>
      </div>
    </div>
  );
}
